import * as yup from "yup";
import {ErrorState} from '../Types'

yup.setLocale({
  string: {
    email:
      "Enter an email address in the correct format (for example, name@example.com)",
  },
});

export async function validate<T extends {}>(
  schema: yup.ObjectSchema<T>,
  val: T,
  paths?: string | string[]
): Promise<[ErrorState<T>, T]> {
  const res: ErrorState<T> = {};
  let list: string[];
  if (typeof paths == "string") {
    list = [paths];
  }
  else if (paths) {
    list = paths;
  }
  else
    list = [""];
  for (let p of list) {
    try {
      if (p != "") {
        await schema.validateAt(p, val, { abortEarly: false });
      }
      else {
        await schema.validate(val, { abortEarly: false });
      }
    } catch (ex) {
      let errs: yup.ValidationError = ex as yup.ValidationError;

      if(!errs.inner) {
        throw ex;
      }

      for (let e of errs.inner) {
        if (!e.path || e.path.length == 0) {
          continue;
        }

        let current = res;
        let parts = e.path.split(".");
        for (let i = 0; i < parts.length; i++) {
          let p = parts[i] as keyof T;
          if (i == parts.length - 1) {
            current[p] = e.message;
          }
          else {
            if (!(p in res)) {
              current[p] = {} as any;
            }
            current = current[p]!;
          }
        }
      };
    }
  }
  return [res, val];
}
